<template>
  <div class="section-divider">
    <span class="section-divider__title">{{ title }}</span>
    <span class="section-divider__line" aria-hidden="true" />
    <div v-if="$slots.actions" class="section-divider__actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.section-divider {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin: 6px 0 6px;
  color: var(--text-color-secondary);
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  text-transform: uppercase;
}

.section-divider__line {
  flex: 1;
  min-width: 24px;
  height: 1px;
  background: var(--border-color-base);
}

.section-divider__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

@media screen and (max-width: 640px) {
  .section-divider__actions {
    flex-basis: 100%;
  }
}
</style>
